<template>
  <div>
    <iframe
      v-if="autoLoginToken"
      :src="`https://gala.talentprint.com/${autoLoginToken}`"
      class="hidden"
    />
    <Header />
    <Testimonials />
  </div>
</template>
<script>
import Header from "./components/Header";
import Testimonials from "./components/Testimonials";
export default {
  name: "Main",
  components: {
    Header,
    Testimonials,
  },
  computed: {
    autoLoginToken() {
        console.log('this.$store.state.boards.userBoardData',this.$store.state.boards.userBoardData.youlabToken);
        return this.$store.state.boards.userBoardData.youlabToken;
    },
  },
  created() {
    this.$store.commit("SET_PAGE_TYPE", "alex");
    this.$store.commit("SET_PAGE_FOOTER_BACKGROUND_COLOR", "#F7F7F7");
    // const userId = this.$route.params.userId;
    // // this.$store
    // //   .dispatch("boards/fetchUserBoardData",userId )
    // //   .catch((err) => {
    // //     throw err;
    // //   })
    // //   .finally(() => {
    // //     this.$vs.loading.close();
    // //   });

    // console.log(
    //   "Background Color",
    //   this.$store.state.pageFooterBackgroundColor
    // );
  },
};
</script>
